import React from "react";

import {
  Container,
  Content,
  Image,
  ImageContainer,
  Rating,
  SubTitle,
  Tag,
  Title,
  ViewGuide,
} from "./styles";

function GuideCard({ inHeader = false, data, onClick }) {
  const {
    tag,
    rating,
    pageHeaderText,
    description,
    shortDescription,
    illustration,
  } = data ?? {};

  return (
    <Container className="guide-card" $inHeader={inHeader}>
      <ImageContainer $isNoImage={!illustration} data-header={pageHeaderText}>
        {!!illustration && <Image src={illustration} alt="Illustration" />}
        <Tag>{tag || pageHeaderText}</Tag>
        {!!rating && (
          <Rating>
            {typeof rating === "number"
              ? rating.toLocaleString("en-US", {
                  maximumFractionDigits: 1,
                })
              : rating}
          </Rating>
        )}
      </ImageContainer>
      <Content className="guide-card-info" $inHeader={inHeader}>
        <Title className="guide-card-title" $inHeader={inHeader}>
          {pageHeaderText || ""}
        </Title>
        <SubTitle $inHeader={inHeader}>
          {shortDescription ||
            description ||
            `Get Answers to all your ${
              pageHeaderText?.toLowerCase() || ""
            } questions in one place`}
        </SubTitle>
        <ViewGuide
          className="view-guide-btn"
          onClick={onClick}
          $inHeader={inHeader}
        >
          View Guide
          <img src="/images/icons/arrow-top-right.svg" alt="Arrow right" />
        </ViewGuide>
      </Content>
    </Container>
  );
}

export default GuideCard;
